import React from "react";

const ConfirmDisburseModal = ({
  isConfirmDisburseModalOpen,
  closeConfirmDisburseModal,
  handleConfirmDisburse,
  handleConfirmDisburseCancel,
}) => {
  if (!isConfirmDisburseModalOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-10 p-4">
      <div className="relative bg-white shadow max-w-[60%] h-[50%] mx-auto p-6 rounded-sm flex flex-col">
        {/* Close Button */}
        <button
          onClick={closeConfirmDisburseModal}
          className="text-black text-xl font-bold absolute top-4 right-4"
        >
          ✖
        </button>

        {/* Title */}
        <h2 className="text-2xl font-bold mb-4">Disburse Funds</h2>

        {/* Warning Section */}
        <div className="bg-[#F2F9F2] border-l-4 border-[#005C53] p-4">
          <p className="text-red-600 text-lg font-bold flex items-center">
            <img src="/red-warning.png" alt="red-warning" className="mr-2" />
            Warning
          </p>
          <p className="text-[#005C53] text-sm mt-2">
            By clicking 'Yes, I Confirm,' you acknowledge that you have
            thoroughly reviewed all loan details, member information, and
            disbursement account details and are now ready to proceed with
            disbursing the funds.
          </p>
          <p className="text-[#005C53] text-sm">
            Disbursing this loan commits the Sacco to transferring funds to the
            applicant. Ensure that all verification steps have been completed
            and that the transaction details are accurate before proceeding.
          </p>
          <p className="text-[#005C53] text-sm mt-4">
            Are you sure you want to{" "}
            <span className="font-semibold">continue</span>?
          </p>
        </div>

        {/* Spacer to push buttons down */}
        <div className="flex-grow"></div>

        {/* Action Buttons */}
        <div className="flex justify-start mt-2">
          <button
            onClick={handleConfirmDisburseCancel}
            className="flex justify-center items-center px-6 py-3 border border-red-500 text-red-500 font-semibold rounded-lg w-[180px] h-[51px] mr-2"
          >
            No, Cancel
          </button>
          <button
            onClick={handleConfirmDisburse}
            className="flex justify-center items-center px-6 py-3 border border-[#005C53] text-[#005C53] font-semibold rounded-lg w-[180px] h-[51px] whitespace-nowrap"
          >
            Yes, I Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDisburseModal;
